import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import icPerson from '@iconify/icons-ic/twotone-person';
import icSwitch from '@iconify/icons-fa-solid/random';
import icInfo  from '@iconify/icons-ic/info';
import icRoute from '@iconify/icons-fa-solid/share';
import icBriefCase from '@iconify/icons-fa-solid/briefcase';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { BusinessGroupManagementService } from 'src/app/services/business-group-management.service';
import { LoadingService } from 'src/app/services/loading.service';
import { Message } from 'src/app/interfaces/message.model';
import { CookieService } from 'ngx-cookie-service';
import { NavigationService } from 'src/@vex/services/navigation.service';
import { active_session_details } from 'src/app/services/users.service';



@Component({
  selector: 'vex-switch-to',
  templateUrl: './switch-to.component.html',
  styleUrls: ['./switch-to.component.scss', '/src/@vex/layout/toolbar/toolbar-user/toolbar-user-dropdown/toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchToComponent implements OnInit{

  constructor(
    private cd: ChangeDetectorRef,
              private popoverRef: PopoverRef<SwitchToComponent>,
              public businessGroupService: BusinessGroupManagementService,
              public broadcastService:BroadcastService,
              private loadingService: LoadingService,
              private dialog: MatDialog,
              private router: Router,
              public cookieService: CookieService,
              public navigationService: NavigationService,
  ) { 

  }

  icPerson = icPerson;
  icSwitch = icSwitch;
  icRoute = icRoute;
  icInfo = icInfo;
  icBriefCase = icBriefCase;
  switchToitems:any = [];

  ngOnInit() {
    // this.getSwitchToItems()
    //console.log(this.popoverRef.data)
    this.switchToitems = this.popoverRef.data;
    
  }

  


  getSwitchToItems(){
    // 
    this.loadingService.showLoader();
    this.businessGroupService.BusinessgroupTable('','','').subscribe((response) => {
    
      if(response.data){
        this.switchToitems = response.data;
        //console.log(this.switchToitems)
      }
      this.loadingService.hideLoader()
    }, (error) => {
      this.broadcastService.sessionCheck(error);
      //console.log(error)
      this.loadingService.hideLoader()
    })
  }

  changeRoute(routeUrl){
  this.router.navigate([routeUrl]);
  this.broadcastService.dispatch(new Message('changeSideNavOnSwitch',null))
  this.close()
  }

  switchTo(bg_id){
    if(bg_id){
      let old_bg_id = this.cookieService.get('bg_id')
      this.businessGroupService.switchTo(bg_id).subscribe((response) => {
        //console.log(response);
        //store bg id and replace it with cookies bg_id key
  
        this.cookieService.set('bg_id', response['data']['bg_data']['bg_id'])
        this.cookieService.set('bg_authtoken',response['data']['bg_data']['authentication_token'])
        this.businessGroupService.handleCookieData();
        // active_session_details.active_session = `${this.cookieService.get('user_session_id')}&bg_id=${response['data']['bg_data']['bg_id']}` 
        // //console.log(active_session_details)
        //store groupname and add extra name as groupname
        this.cookieService.set('bg_user_name', response['data']['bg_data']['groupname'])
        this.close()
        // if(location.href.split("#")[1] === '/cms/business-group'){
          this.broadcastService.dispatch(new Message('switchToPrivileges', response.data['user_data']['user_privileges']))
        // }

        if(location.href.split("#")[1] !== '/cms/catalogs'){
          if( old_bg_id !=  bg_id )
          {
            this.cookieService.set('bg_id', bg_id)
            this.router.navigate(['/cms/catalogs'], {state: {switch_bg : true}} );
            
          }
          
        }else{
          location.reload();
        }
        
      }, (error) => {
        //console.log(error)
        this.broadcastService.sessionCheck(error)
      })
    }
    
  }



  close()
  {
   this.popoverRef.close();
  }
}

export function switchTo(bg_id,  businessGroupService: BusinessGroupManagementService, cookieService:CookieService, broadcastService:BroadcastService){
  if(bg_id){
    
    businessGroupService.switchTo(bg_id).subscribe((response) => {
      //console.log(response);
      //store bg id and replace it with cookies bg_id key

      cookieService.set('bg_id', response['data']['bg_data']['bg_id'])
      cookieService.set('bg_authtoken',response['data']['bg_data']['authentication_token'])
      //store groupname and add extra name as groupname
      cookieService.set('bg_user_name', response['data']['bg_data']['groupname'])
      // this.close()
      //change sidenav items on switch user

      // ;
     broadcastService.dispatch(new Message('switchToPrivileges', response.data['user_data']['user_privileges']))
     //console.log('switchToPrivileges dispatch')
    }, (error) => {
      //console.log(error)
      broadcastService.sessionCheck(error)
    })
  }

  
}
